export const displayBytesWithMUnit = (bytes: number, decimals = 2): string => {
  if (bytes < 1024) return `${bytes}B`

  const kb = bytes / 1024

  if (kb < 1000) return `${kb.toFixed(decimals)}KB`

  const mb = kb / 1024

  if (mb < 1000) return `${mb.toFixed(decimals)}MB`

  const gb = mb / 1024

  return `${gb.toFixed(decimals)}GB`
}

export const displayIntegerWithMunit = (number: number, decimals = 2): string => {
  if (number < 1000) return `${number}`

  const k = number / 1000

  if (k < 1000) return `${k.toFixed(decimals)}K`

  const m = k / 1000

  if (m < 1000) return `${m.toFixed(decimals)}M`

  const b = m / 1000

  return `${b.toFixed(decimals)}B`
}

export const convertSecondsToMinutes = (number: number): string => {
  if (number <= 0) return '0 sec'
  if (number < 1) return '<1 sec'

  const units: [number, string][] = [
    [60 * 60 * 24, 'day'],
    [60 * 60, 'h'],
    [60, 'min'],
    [1, 'sec'],
  ]

  const parts: string[] = []
  let remaining = number

  for (const [divisor, label] of units) {
    if (remaining >= divisor) {
      const val = Math.floor(remaining / divisor)
      parts.push(`${val} ${label}`)
      remaining = remaining % divisor
    }
  }

  return parts.slice(0, 2).join(' ')
}

export const getNumberWithRegex = (string: string): string => {
  return string?.replace(/\D+/g, '')
}
